import { Stack, Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { useTranslate } from "src/locales";
import ByzMuiButton from "src/components/core-components/mui/buttons/ByzMuiButton";
import { PAGE_THREE_STYLES } from "../constants";

const ActionButton = ({ label, onClick, t }: { label: string; onClick: () => void; t: any }) => (
  <Grid md={4} xs={4} sx={PAGE_THREE_STYLES.gridItem}>
    <ByzMuiButton
      onClick={onClick}
      marginLeft="0px"
      sx={PAGE_THREE_STYLES.actionButton}
    >
      {t(label)}
    </ByzMuiButton>
  </Grid>
);

const HistoryActionButtons: React.FC = () => {
  const { t } = useTranslate();

  return (
    <Box sx={PAGE_THREE_STYLES.buttonGroup}>
      <Stack direction="row" sx={{ paddingTop: "10px" }} flexWrap="wrap" spacing={2}>
        <ActionButton label="adult-patient-assessment.allergies" onClick={() => console.log("Alerjiler")} t={t} />
        <ActionButton label="adult-patient-assessment.habits" onClick={() => console.log("Alışkanlıklar")} t={t} />
        <ActionButton label="adult-patient-assessment.family-history" onClick={() => console.log("Soy Geçmiş")} t={t} />
        <ActionButton label="adult-patient-assessment.past-illnesses" onClick={() => console.log("Geçirilmiş Hastalıklar")} t={t} />
        <ActionButton label="adult-patient-assessment.diseases" onClick={() => console.log("Hastalıklar")} t={t} />
        <ActionButton label="adult-patient-assessment.past-surgeries" onClick={() => console.log("Geçirilmiş Ameliyatlar")} t={t} />
      </Stack>
      
      <Stack direction="row" sx={{ paddingTop: "10px" }} flexWrap="wrap" spacing={2}>
        <ActionButton label="adult-patient-assessment.special-notes" onClick={() => console.log("Özel Notlar")} t={t} />
        <ActionButton label="adult-patient-assessment.rare-diseases" onClick={() => console.log("Nadir Hastalıklar")} t={t} />
        <ActionButton label="adult-patient-assessment.blood-pressure-monitoring" onClick={() => console.log("Tansiyon Takibi")} t={t} />
        <ActionButton label="adult-patient-assessment.exposures" onClick={() => console.log("Maruziyetler")} t={t} />
        <ActionButton label="adult-patient-assessment.current-medications" onClick={() => console.log("Kullandığı İlaçlar")} t={t} />
      </Stack>
    </Box>
  );
};

export default HistoryActionButtons;
